export const availableBurdenedDecks = [1, 1.5, 2, 3, 4, 5, 6];
